import { useState, useEffect } from 'react';
import { useKeycloak } from "@react-keycloak/web";
import { ProvidersService } from "../services/ProvidersService";

/**
 * Custom hook to determine if the current authenticated user is a provider.
 * A user is considered a provider if they have at least one provider record.
 *
 * @returns {boolean} true if user is authenticated and has providers, false otherwise
 */
export const useIsProvider = () => {
    const { keycloak } = useKeycloak();
    const [isProvider, setIsProvider] = useState(false);

    useEffect(() => {
        if (keycloak.authenticated) {
            try {
                // Pass keycloak directly: Hook may be used on public routes
                // where ProvidersService.keycloak has not been set by PrivateRoute yet.
                // /mine returns an array (empty if no providers), so "is this user
                // a provider?" reduces to "does the array have anything in it?"
                ProvidersService.getMyProviders(keycloak).then((providers) => {
                    setIsProvider(Array.isArray(providers) && providers.length > 0);
                }).catch(() => {
                    setIsProvider(false);
                });
            } catch (e) {
                if (e.response && e.response.status === 404) {
                    setIsProvider(false);
                } else {
                    setIsProvider(false);
                }
            }
        }
    }, [keycloak, keycloak.authenticated]);

    return isProvider;
};
